const localState = {
    list: [],
    todo: {
        client_id: null,
        comment: '',
        is_done: false,
    },
    isShowModal: false,
}
const mutations = {
    setState: (state, {
        key,
        data,
    }) => {
        state[key] = data
    },
}

const actions = {
    async fetch({
        commit,
    }, data) {
        const response = await this.$api.todo.fetch(data)
        commit('setState', {
            key: 'list',
            data: response.data.data,
        })
    },
    async add(_, form) {
        const response = await this.$api.todo.add(form)
        return response.status === 201
    },
    async update(_, form) {
        const response = await this.$api.todo.update(form)
        return response.status === 200
    },
    async remove(_, id) {
        await this.$api.todo.remove(id)
    },
}

const getters = {
    list: (state) => state.list,
    todo: (state) => state.todo,
    isShowModal: (state) => state.isShowModal,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
